import React from 'react';
import EntityTasks from '../../../shared/EntityTasks';
import {OwnerType} from '../../../../constants/EntityTypeNames';
import {getStyle} from '../../../../styles/styles'
var style = getStyle();

export default class OwnerTasks extends React.Component {
    state = {
        ownerID: 0,
        entityTasksSaveProcess: false,
    }

    onFinishEntityTasksSaveProcess(){
        this.props.getSaveTasks(false);
    }

    render(){
        var section = (
                <form className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-1 uk-margin">
                        <EntityTasks fullScreen={true} entityType={OwnerType} entityID={this.props.ownerID} personID={this.props.personID}  runSaveProcess={this.props.saveTasks} finishSaveProcess={this.onFinishEntityTasksSaveProcess.bind(this)} />
                    </div>
                </form>
            )
        if(this.props.ownerID === ''){
            section = (
                <div>
                    <h5 style={style.alignCenter}>Must create owner first.</h5>
                </div>
            )
        }
        return(
            <div>
            {section}
            </div>
        );
    }
}